module.exports = __webpack_public_path__ + "static/media/incomplete.6d76485b.svg";